export default __webpack_public_path__ + "static/media/event_placeholder_img.4f01a2f8.jpg";